<script setup>
import { ref } from "vue";
import useActionButtonsCommon from "@/composables/ActionButtonsCommon";

const { store, loading, _error } = useActionButtonsCommon();

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(["update:modelValue"]);

const devices = ref({
  imeis: "",
});

const closeModal = () => {
  _error.value = null;
  emit("update:modelValue", false);
  devices.value.imeis = "";
};

const requestDeviceCacheClear = async () => {
  if (devices.value.imeis.trim()) {
    try {
      loading.value = true;
      const response = await store.dispatch(
        "devices/clearMultiDeviceCache",
        devices.value
      );

      await store.dispatch("toastNotification/displayToast", {
        message: response?.message || "Cache cleared successfully",
        type: "success",
      });

      loading.value = false;
      closeModal();
    } catch (error) {
      loading.value = false;

      const errorMessage = error?.message || "Error clearing cache";
      _error.value = errorMessage;

      await store.dispatch("toastNotification/displayToast", {
        message: errorMessage,
        type: "warning",
      });

      console.error("Error clearing cache:", error);
    }
  }
};
</script>

<template>
  <div v-if="modelValue">
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
      <div class="modal-backdrop fade show" @click="closeModal"></div>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Clearing Cache For Devices</h4>
            <button type="button" class="close" @click="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="form-group">
              <textarea
                class="form-control bg-white"
                rows="10"
                v-model="devices.imeis"
                placeholder="Enter device imei in each line"
              ></textarea>
            </div>
            <p v-if="_error" class="text-danger">
              {{ _error }}
            </p>
          </div>

          <div class="modal-footer justify-content-end">
            <button type="button" class="btn btn-danger" @click="closeModal">
              CLOSE
            </button>
            <button
              v-if="!loading"
              type="button"
              class="btn btn-success"
              @click="requestDeviceCacheClear"
              :disabled="devices.imeis.trim() === ''"
            >
              CLEAR
            </button>
            <div
              v-if="loading"
              class="justify-content-center align-items-center"
              style="text-align: center"
            >
              <font-awesome-icon :icon="['fas', 'spinner']" spin size="2x" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "@/styles/modal.css";

.form-control {
  resize: none;
}
</style>
